import styled from "styled-components";
import { Link } from "react-router-dom";
import { BodySmall, BodySmallMedium, VerySmall } from "../../../../../../components/typography/styled";

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SummaryRow = styled.div`
  display: flex;
  gap: 12px;
  margin: 14px 0px;
  flex-wrap: wrap;
`;

export const SummaryPill = styled.div`
  background-color: ${({theme}) => theme.primary[25]};
  color: ${({theme}) => theme.primary[700]};
  border-radius: 999px;
  padding: 4px 12px;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
`;

export const ResourcesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 18px;
  width: 100%;
`;

export const ResourceCard = styled.div`
  background-color: ${({theme}) => theme.base.white};
  border-radius: 12px;
  padding: 18px;
  border: 1px solid ${({theme}) => theme.palette[200]};
  box-shadow: 0px 10px 24px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 180px;
`;

export const ResourceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const CountBadge = styled.div`
  background: ${({theme}) => theme.primary[25]};
  border-radius: 999px;
  color: ${({theme}) => theme.primary[700]};
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  padding: 4px 12px;
  white-space: nowrap;
`;

export const ResourceList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
`;

export const ResourceItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 12px;
  background-color: ${({theme}) => theme.palette[100]};
  border-radius: 10px;
  border: 1px solid ${({theme}) => theme.palette[200]};
  word-break: break-word;
`;

export const ItemTitle = styled(BodySmallMedium)`
  color: ${({theme}) => theme.palette[900]};
`;

export const ItemMeta = styled(BodySmall)`
  color: ${({theme}) => theme.palette[700]};
`;

export const IpList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const IpTag = styled(VerySmall)`
  background-color: ${({theme}) => theme.palette[200]};
  border-radius: 6px;
  padding: 4px 8px;
  color: ${({theme}) => theme.palette[800]};
  letter-spacing: 0.02em;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: auto;
`;

export const FooterText = styled(VerySmall)`
  color: ${({theme}) => theme.palette[700]};
`;

export const ItemLink = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  height: 100%;
  color: inherit;
  text-decoration: none;
  &:hover ${ItemTitle} {
    color: ${({theme}) => theme.primary[600]};
  }
`;

export const EmptyCardState = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 24px 12px;
  color: ${({theme}) => theme.palette[700]};
  text-align: center;
`;

export const SkeletonGrid = styled(ResourcesGrid)`
  opacity: 0.7;
`;

export const PageEmptyState = styled(EmptyCardState)`
  border: 1px dashed ${({theme}) => theme.palette[200]};
  border-radius: 12px;
  padding: 40px 20px;
  background-color: ${({theme}) => theme.palette[100]};
`;

export const FooterLink = styled(Link)`
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  color: ${({theme}) => theme.primary[600]};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
